import { AxiosInstanceBasic } from '../utils/AxiosConfig';
import { getOrderUrl, getLoginUrl, isOrderUrl, isLoginUrl } from '../utils/urlUtils';

class AxiosInstance {
    constructor() {
        this.queue = [];
        this.instance = AxiosInstanceBasic({
            baseUrl: process.env.REACT_APP_BASE_ORIGIN_URL.replace('{origin}', window.location.origin),
        });
    }

    get(url, config) {
        return this.instance.get(isOrderUrl(url) ? getOrderUrl(url) : isLoginUrl(url) ? getLoginUrl(url) : url, config);
    }
    post(url, data, config) {
        return this.instance.post(
            isOrderUrl(url) ? getOrderUrl(url) : isLoginUrl(url) ? getLoginUrl(url) : url,
            data,
            config
        );
    }
    put(url, data, config) {
        return this.instance.put(
            isOrderUrl(url) ? getOrderUrl(url) : isLoginUrl(url) ? getLoginUrl(url) : url,
            data,
            config
        );
    }
    patch(url, data, config) {
        return this.instance.patch(
            isOrderUrl(url) ? getOrderUrl(url) : isLoginUrl(url) ? getLoginUrl(url) : url,
            data,
            config
        );
    }
    delete(url, config) {
        return this.instance.delete(isOrderUrl(url) ? getOrderUrl(url) : isLoginUrl(url) ? getLoginUrl(url) : url, config);
    }
    head(url, config) {
        return this.instance.head(isOrderUrl(url) ? getOrderUrl(url) : isLoginUrl(url) ? getLoginUrl(url) : url, config);
    }
    options(url, config) {
        return this.instance.options(isOrderUrl(url) ? getOrderUrl(url) : isLoginUrl(url) ? getLoginUrl(url) : url, config);
    }
    fetch(...args) {
        switch (args?.length) {
            case 1:
                const config = args[0];
                return this.instance(config);
            case 2:
                const url = args[0];
                const options = args[1];
                return this.instance(isOrderUrl(url) ? getOrderUrl(url) : isLoginUrl(url) ? getLoginUrl(url) : url, options);
            default:
                return Promise.reject();
        }
    }
}

export default AxiosInstance;
